/* eslint-disable max-lines-per-function */
import React from "react";
import { useTheme } from "@mui/material/styles";
import { Viewer } from "components/auth/types";
import { useInterestsTable } from "./table-context";

const buttonStyle = {
  border: "none",
  background: "none",
  textDecoration: "underline",
};

const InterestSelectionPrompt: React.FC<{
  totalSelectionCount: number;
  selectedCount: number;
  viewer: Viewer;
  currentListId: string;
}> =
(props) => {
  const theme = useTheme();
  const {
    tableResults,
    selectAllInterests,
    deselectAllInterests: handleDeselectAll,
    hasSelectedAllInterests,
    totalTableResults,
    selectedPageRange,
    fullPageOrAllPagesSelected,
  } = useInterestsTable();

  const applySelectAll = () => {
    const visibleIds = tableResults.map(interest => interest.id);
    selectAllInterests(visibleIds);
  };

  const totalCount = () =>
    (hasSelectedAllInterests ? totalTableResults : props.selectedCount);


  const { from, to } = selectedPageRange;
  const isPageRangeSelected = from !== null || to !== null;
  const showPrompt = fullPageOrAllPagesSelected || isPageRangeSelected;

  // Color-coded by blast radius: Select All is the highest-risk scope (every
  // applicant matching the current search), a page range is a bounded but
  // still multi-page scope, and the default (current page only) is lowest-risk.
  // Colors come from the theme palette rather than hardcoded hex values.
  const backgroundColor = (() => {
    if (hasSelectedAllInterests) return theme.palette.error.light;
    if (isPageRangeSelected) return theme.palette.warning.light;
    return theme.palette.primary.dark;
  })();

  const textColor = !isPageRangeSelected ? theme.palette.common.white : undefined;

  const selectAllButton = (
    <button onClick={applySelectAll} style={buttonStyle}>
        Select all <b>{totalTableResults}</b> applications
    </button>
  );

  const deselectButton = (
    <button onClick={handleDeselectAll} style={buttonStyle}>
        Clear selection
    </button>
  );

  return (
    showPrompt ? (
      <div
        style={{
          backgroundColor,
          color: textColor,
          textAlign: "center",
          padding: "8px",
          margin: "8px 0 8px",
        }}
      >
        <span>
          {isPageRangeSelected ? (
            `Selected applicants on pages ${from === null ? "" : `${from + 1}`} ${to === null ? "" : `to ${to + 1}`}: `) : <>
            All <b>{totalCount()}</b> applications&nbsp;
            {(hasSelectedAllInterests || isPageRangeSelected) ? "in this search " : "on this page "}
            are selected.
          </>}
        </span>
        {hasSelectedAllInterests ? deselectButton : selectAllButton}
      </div>
    ) : null
  );
};

export default InterestSelectionPrompt;
